import React, { useState } from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, Heading } from './ui';
import Filters from './Filters';
import SpaSeekersReviews from './SpaSeekersReviews';
import TripAdvisorReviews from './TripAdvisorReviews';

const StyledSpaReviews = styled.section`
  ${sectionMargins()};
`;

const SpaReviews = ({ spaSeekers, tripAdvisor, altTheme }) => {
  const [activeFilters, setActiveFilters] = useState('spaseekers');

  const handleActiveFilters = value => {
    setActiveFilters(value);
  };

  const filterItems = [];

  if (spaSeekers) {
    filterItems.push({
      name: 'SpaSeekers',
      value: 'spaseekers',
    });
  }

  if (tripAdvisor) {
    filterItems.push({
      name: 'TripAdvisor',
      value: 'tripadvisor',
    });
  }

  return (
    (spaSeekers || tripAdvisor) && (
      <StyledSpaReviews id="spa-reviews">
        <Container narrow={true}>
          <Heading>Reviews</Heading>
          {filterItems.length > 1 && (
            <Filters
              heading="Filter Reviews"
              items={filterItems}
              radioInput="reviews-type"
              activeFilters={activeFilters}
              handleActiveFilters={handleActiveFilters}
              altTheme={altTheme}
            />
          )}
          {spaSeekers && (
            <SpaSeekersReviews
              {...spaSeekers}
              display={activeFilters === 'spaseekers'}
              altTheme={altTheme}
            />
          )}
          {tripAdvisor && (
            <TripAdvisorReviews
              {...tripAdvisor}
              display={activeFilters === 'tripadvisor'}
              altTheme={altTheme}
            />
          )}
        </Container>
      </StyledSpaReviews>
    )
  );
};

export default SpaReviews;
